import SpinnerSVG from "../../assets/spinner.svg"

export const Spinner = () => {
	return (
		<div className="absolute flex h-full w-full items-center justify-center bg-none">
			<img src={SpinnerSVG} className="bg-none" />
		</div>
	)
}
